import { createElement, Fragment } from 'react';
import { Button, ButtonVariant } from '../../Button';
import {
  ArrowSmallUp,
  ArrowSmallDown,
  ArrowSmallUpEnd,
  ArrowSmallDownEnd,
  Delete,
} from '@sas/react-svg';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import bundle from '../NovaComponents-DualSelector-gui-icu.properties';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { SVGIconDescriptor } from '../../SVG';
import { postfixTestId, TestIdProps } from '../../../util/testId';

import './ReorderLayout.css';
import cn from './ReorderLayout.css.json';

export type ReorderButtonDirection = 'top' | 'up' | 'bottom' | 'down' | 'delete';
export interface ReorderButtonProps extends TestIdProps {
  onPress: (direction: ReorderButtonDirection) => void;
  reorderButtonState: { disableUp: boolean; disableDown: boolean; disableDelete: boolean };
  targetLabel: string;
  hideReorder: boolean;
  hideDelete: boolean;
}

const useTextLocalizer = createUseTextLocalizer(bundle);

export const ReorderButton = (props: ReorderButtonProps) => {
  const dt = useDesignTokens();
  const reorderButtonTokens = renderInlineCssVars(
    {
      spacing: dt.spacing.core.s,
    },
    'reorder-button'
  );

  const localize = useTextLocalizer();

  const reorderItems: {
    direction: ReorderButtonDirection;
    icon: SVGIconDescriptor;
    isDisabled: boolean;
    hide: boolean;
  }[] = [
    {
      direction: 'top',
      icon: ArrowSmallUpEnd,
      isDisabled: props.reorderButtonState.disableUp,
      hide: props.hideReorder,
    },
    {
      direction: 'up',
      icon: ArrowSmallUp,
      isDisabled: props.reorderButtonState.disableUp,
      hide: props.hideReorder,
    },
    {
      direction: 'down',
      icon: ArrowSmallDown,
      isDisabled: props.reorderButtonState.disableDown,
      hide: props.hideReorder,
    },
    {
      direction: 'bottom',
      icon: ArrowSmallDownEnd,
      isDisabled: props.reorderButtonState.disableDown,
      hide: props.hideReorder,
    },
    {
      direction: 'delete',
      icon: Delete,
      isDisabled: props.reorderButtonState.disableDelete,
      hide: props.hideDelete,
    },
  ];
  return (
    <Fragment>
      {reorderItems.map((item, i) => {
        if (item.hide) {
          return null;
        } else {
          return (
            <div className={cn.reorderButtons} style={reorderButtonTokens} key={i}>
              <Button
                testId={postfixTestId(props.testId, item.direction)}
                variant={ButtonVariant.Icon}
                icon={{
                  icon: item.icon,
                  tooltip: localize(`reorderButton.${item.direction}.button.tooltip.label`),
                }}
                onPress={() => props.onPress(item.direction)}
                disabled={item.isDisabled}
                ariaLabel={localize(`reorderButton.${item.direction}.button.aria`, {
                  targetListLabel: props.targetLabel,
                })}
              />
            </div>
          );
        }
      })}
    </Fragment>
  );
};
